import { jsx as e } from "react/jsx-runtime";
import o, { SkeletonTheme as t } from "react-loading-skeleton";
/* empty css                                                                */
import r from "./input-skeleton-loader.module.less.js";
const i = () => /* @__PURE__ */ e("div", { className: r.wrapper, children: /* @__PURE__ */ e(
  t,
  {
    borderRadius: "var(--core-border-radius-default)",
    baseColor: "var(--ctx-skeleton-loader-background",
    highlightColor: "var(--ctx-skeleton-loader-highlights)",
    children: /* @__PURE__ */ e(o, { duration: 1.8, className: r.skeleton })
  }
) });
export {
  i as default
};
